import React from "react";
import "./Team.css";
import Navbar from "./Navbar";
import Footer from "./Footer";

import allocation1 from "../assets/Allocation/allocation.jpg";
import allocation2 from "../assets/Allocation/allocation2.jpg";
import allocation3 from "../assets/Allocation/allocation3.jpg";
import allocation4 from "../assets/Allocation/allocation4.jpg";
import allocation5 from "../assets/Allocation/allocation5.jpg";
import allocation6 from "../assets/Allocation/allocation6.jpg";
import allocation7 from "../assets/Allocation/allocation7.jpg";
import allocation8 from "../assets/Allocation/allocation8.jpg";
import allocation9 from "../assets/Allocation/allocation9.jpg";
import allocation10 from "../assets/Allocation/allocation10.jpg";
import allocation11 from "../assets/Allocation/allocation11.jpg";
import allocation12 from "../assets/Allocation/allocation12.jpg";
import allocation13 from "../assets/Allocation/allocation13.jpg";
import allocation14 from "../assets/Allocation/allocation14.jpg";
import allocation15 from "../assets/Allocation/allocation15.jpg";
import allocation16 from "../assets/Allocation/allocation16.jpg";
import allocation17 from "../assets/Allocation/allocation17.jpg";
import allocation18 from "../assets/Allocation/allocation18.jpg";

const Images = [
  {
    title: "Site View at Highbridge Gardens – Peaceful Vibes",
    image: allocation1,
  },
  {
    title: "Exploring Our Newly Allocated Plots",
    image: allocation2,
  },
  {
    title: "Customer Allotment Day at Highbridge Site",
    image: allocation3,
  },
  {
    title: "From Land to Legacy – Physical Allocation Highlights",
    image: allocation4,
  },
  {
    title: "Plot Allocation Ceremony – A Step Toward Ownership",
    image: allocation5,
  },
  {
    title: "Clear Boundaries, Clear Ownership",
    image: allocation6,
  },
  {
    title: "From Paper to Property – Allocation in Progress",
    image: allocation7,
  },
  {
    title: "Where Dreams Take Shape – Actual Land View",
    image: allocation8,
  },
  {
    title: "Your Plot. Your Pride.",
    image: allocation9,
  },
  {
    title: "Clients Receiving Keys to Their Future",
    image: allocation10,
  },
  {
    title: "Turning Soil into Shelter – Plot Allocation Day",
    image: allocation11,
  },
  {
    title: "Verified & Allocated – Welcome to Your Future Home",
    image: allocation12,
  },
  {
    title: "Celebrating Your First Step into Land Ownership",
    image: allocation13,
  },
  {
    title: "Our Site Engineers Guiding Clients through Layout",
    image: allocation14,
  },
  {
    title: "Hands-On Land Handover Moments",
    image: allocation15,
  },
  {
    title: "Surveyors Marking Out Your Piece of the Future",
    image: allocation16,
  },
  {
    title: "Invested and Allocated – Confidence in Every Plot",
    image: allocation17,
  },
  {
    title: "Highbridge Clients Walking Their Allocated Grounds",
    image: allocation18,
  },
];

const videoData = [
  {
    title: "Massive development going on at HIGHBRIDGE CEDARS",
    link: "https://youtu.be/tSsgpv0JILk",
  },
  {
    title: "NOLLYWOOD ACTRESS JOKE JIGAN INVESTED WITH HIGHBRIDGE",
    link: "https://youtu.be/mCV6PjoEgQc",
  },
  {
    title: "A NIGHT OF CHAMPIONS 2.0 (FULL VIDEO OF THE EVENT)",
    link: "https://youtu.be/yBHX0UaNwmw",
  },
  {
    title:
      "Highbridge Homes Rewards Excellence: Congratulations to Mrs. Juliet Arinze on Winning a Mercedes Benz ML350 4MATIC!",
    link: "https://youtu.be/Ag90nRN2Gho",
  },
  {
    title:
      "Discussing Recent Real Estate Trends - M.D CEO Highbridge Homes Limited",
    link: "https://youtu.be/AtgLYOr9yVI",
  },
  {
    title:
      "At Highbridge Homes Limited, we have our clients' trust in the fore-front of our timeline and we are ready to build your trust from the ground up",
    link: "https://youtu.be/1-JR4GrX19I",
  },
  {
    title: "ABN Property Tour: Highbridge Residence",
    link: "https://youtu.be/ez695RcYCh4",
  },
  {
    title: "When your odogwu is an investor and king of doings",
    link: "https://youtu.be/H0xlt_UiRYw",
  },
  {
    title: "Peak Performance 001: Highbridge Group Staff Training",
    link: "https://youtu.be/dDvFQ9gkDE8",
  },
  {
    title: "A Tale Of Trust from Highbridgegroup",
    link: "https://youtu.be/QWsah_8MXPo",
  },
];

const getYouTubeID = (url) => {
  const regex = /(?:youtu\.be\/|v=)([a-zA-Z0-9_-]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
};

const Events = () => {
  return (
    <>
      <Navbar />
      <div style={{ padding: "2rem", backgroundColor: "#014B2C" }}>
        <h2
          style={{
            textAlign: "center",
            marginBottom: "2rem",
            fontSize: "2rem",
          }}
        >
          Image Highlights
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "1.5rem",
          }}
        >
          {Images.map((item, index) => (
            <div
              key={index}
              style={{
                backgroundColor: "#fff",
                borderRadius: "10px",
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                transition: "transform 0.3s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.02)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            >
              <img
                src={item.image}
                alt={item.title}
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                }}
              />
              <div style={{ padding: "1rem" }}>
                <h3 style={{ fontSize: "1.1rem", margin: 0 }}>{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ padding: "2rem", backgroundColor: "#014B2C" }}>
        <h2 style={{ textAlign: "center", marginBottom: "2rem" }}>
          Video Highlights
        </h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "1.5rem",
          }}
        >
          {videoData.map((video, index) => {
            const videoId = getYouTubeID(video.link);
            const thumbnailUrl = videoId
              ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
              : "https://via.placeholder.com/250x150?text=No+Thumbnail";

            return (
              <a
                key={index}
                href={video.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  background: "#f9f9f9",
                  borderRadius: "10px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                  transition: "transform 0.2s ease-in-out",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.02)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <img
                  src={thumbnailUrl}
                  alt={video.title}
                  style={{ width: "100%", height: "auto", display: "block" }}
                />
                <div style={{ padding: "1rem" }}>
                  <h3
                    style={{
                      fontSize: "1rem",
                      lineHeight: "1.4",
                    }}
                  >
                    {video.title}
                  </h3>
                </div>
              </a>
            );
          })}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Events;
